enum PatchCornerType {
  TOP_LEFT = "Top Left",
  TOP_RIGHT = "Top Right"
}

export default PatchCornerType